module.exports = __webpack_public_path__ + "img/banner-18.f222cfff.jpg";